export default __webpack_public_path__ + "static/media/readReviewsDark.d15626f8.png";